import { Home, Star } from "@mui/icons-material";
import { Box, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { IUIUserFavoriteModel } from "../../services/ui-personalization-data-service/Models";
import { splitFavoriteDescription } from "../../common/utilities/SplitFavoriteDescription";

export type UserFavoritesListItemProps = {
    item: IUIUserFavoriteModel;
    onClick?: (item: IUIUserFavoriteModel, shiftKey: boolean, ctrlKey: boolean) => void;
};

export function UserFavoritesListItem({
    item,
    onClick
}: UserFavoritesListItemProps) {

    const { viewDescription, objectDescription } = splitFavoriteDescription(item.description);

    return (
        <ListItem disablePadding>
            <ListItemButton
                onClick={(ev) => onClick && onClick(item, ev.shiftKey, ev.ctrlKey)}
                sx={{
                    paddingLeft: 1,
                    paddingRight: 1
                }}
                alignItems={
                    objectDescription
                        ? "flex-start"
                        : "center"
                }
            >
                <ListItemIcon sx={{ marginRight: 1, minWidth: "inherit" }}>
                    {item.isHomeUrl
                        ? <Home />
                        : <Star />
                    }
                </ListItemIcon>
                <ListItemText
                    primary={
                        <Box
                            component="span"
                            sx={{
                                overflow: "hidden",
                                // textOverflow: "ellipsis",
                                // display: "block"
                                whiteSpace: "break-spaces"
                            }}>
                            {viewDescription}
                        </Box>
                    }
                    secondary={
                        <Box
                            component="span"
                            sx={{
                                overflow: "hidden",
                                whiteSpace: "break-spaces",
                            }}>
                            {objectDescription}
                        </Box>
                    }

                />
            </ListItemButton>
        </ListItem>
    );
}


